import ViewHidden from "../../assets/Icons/ViewHidden";
import { Button } from "../Buttons";
import TextInput from "../InputBoxes/TextInput";

const ChangePasswordForm = ({ password, changePasswordHandler, changeConfirmPasswordHandler, conformPassword }) => {
  return (
    <form className="flex flex-col gap-[12px]">
      <div>
        <p className="font-Apparat font-[700] text-[16px] md:text-[20px] leading-[20px] md:leading-[24px] tracking-[-2%] text-[#424952]">
          Enter your new password
        </p>
        <p className="font-Apparat font-[500] text-[10px] md:text-[16px] leading-[14px] md:leading-[19px] tracking-[-2%] text-[#424952] text-opacity-[70%] my-[8px] md:my-[14px]">
          Your new password must be different to previous passwords
        </p>
      </div>
      <TextInput
        value={password}
        type="password"
        onChange={changePasswordHandler}
        inputMode="password"
        placeholder="Enter new Password"
        icons={<ViewHidden />}
        className="max-w-[500px] w-[80dvw] border-0"
      />
      <TextInput
        value={conformPassword}
        type="password"
        onChange={changeConfirmPasswordHandler}
        inputMode="password"
        icons={<ViewHidden />}
        placeholder="Confirm new Password"
        className="max-w-[500px] w-[80dvw] border-0"
      />
      <p className="font-Apparat font-[500] text-[10px] md:text-[16px] leading-[14px] md:leading-[19px] tracking-[-2%] text-[#424952] text-opacity-[70%] my-[8px] md:my-[14px]">
        Set a password with atleast 8 characters with symbols and numbers
      </p>
      <Button
        title="Reset Password"
      />
    </form>
  )
}
export default ChangePasswordForm;